import * as type from "./types";
import { createReducer } from "../../../util/index";

const initialState = {
    // data: [],
};

const eventQNABetReducer = createReducer(initialState) ({
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.payload
    })
});

export default eventQNABetReducer;